import defprotocol from '../defprotocol'
import Function from '../types/Function'

const Stacked = defprotocol({
  pop: Function,
  push: Function
})

export default Stacked
